// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Heading_Wrapper__F63fd","WrapStroke":"Heading_WrapStroke__n4qxF","Text":"Heading_Text__1zNpz"};